
import { defineComponent, watch } from "vue";
import router from "@/router";
import store from "@/store";
import {
    IEnrollmentPhysicalFoldersModel, IAcademicYearModel, ICourseGroupsModel,
    ICoursesModel
} from "@/interfaces/modules";
import EnrollmentPhysicalFoldersService from "@/api/Configuration/EnrollmentPhysicalFoldersService";
import AcademicYearService from "@/api/Configuration/AcademicYearService";
import CourseGroupsService from "@/api/Aula/CourseGroupsService";
import CoursesService from "@/api/Aula/CoursesSevice";
import { SHOW_PRESCHOOL } from "@/enums";
export default defineComponent({
    name: "EnrollmentPhysicalFolderForm",
    data() {
        return {
            academicYears: [] as IAcademicYearModel[],
            coursesGroup: [] as ICourseGroupsModel[],
            courses: [] as ICoursesModel[],
            // igual al TemplateForm: toma id desde ruta
            recordId: (this.$route.params.Id as any) || 0,
            form: {
                record: {} as IEnrollmentPhysicalFoldersModel,
                loading: false,
            },
            locationTokens: [] as string[],
        };
    },
    async mounted() {
        await this.load();
        const id = parseInt(this.recordId as any);

        if (id > 0) {
            const record = await EnrollmentPhysicalFoldersService.GetById(id);
            Object.assign(this.form.record, record);
            this.buildLocationTokens();
        } else {
            // defaults para nuevo
            this.form.record = {
                Id: 0
            } as IEnrollmentPhysicalFoldersModel;

            this.buildLocationTokens();
        }

        this.setupWatcher();

    },
    methods: {
        async load() {
            this.academicYears = await AcademicYearService.GetAcademicYears();
            this.courses = await CoursesService.GetCourses(SHOW_PRESCHOOL.No);
            this.coursesGroup = await CourseGroupsService.GetCourseGroups();
        },
        cancel() {
            router.push({ name: "FoliosEnrollment" });
        },

        async handleSubmit() {
            try {
                this.form.loading = true;
                this.form.record.Folio = (this.form.record.Folio || "").trim();
                this.form.record.SiteName = (this.form.record.SiteName || "").trim();
                this.form.record.AreaName = (this.form.record.AreaName || "").trim();

                await EnrollmentPhysicalFoldersService.Post(this.form.record);

                store.dispatch("core/popupDialog", {
                    text: "Carpeta guardada exitosamente.",
                    type: "success",
                });
                this.form.loading = false;
                this.cancel();
            } catch (err) {
                this.form.loading = false;
                store.dispatch("core/popupDialog", {
                    text: `Error al guardar: ${err}`,
                    type: "error",
                });
            }
        },

        buildLocationTokens() {
            const r = this.form.record;

            const tokens = [
                r.SiteName ? `Sede: ${r.SiteName}` : null,
                r.AreaName ? `Área: ${r.AreaName}` : null,
                r.BuildingName ? `Bloque: ${r.BuildingName}` : null,
                r.FloorName ? `Piso: ${r.FloorName}` : null,
                r.RoomName ? `Cuarto: ${r.RoomName}` : null,
                r.StorageType ? `Tipo: ${r.StorageType}` : null,
                r.StorageCode ? `Código: ${r.StorageCode}` : null,
                r.Shelf ? `Repisa: ${r.Shelf}` : null,
                r.RowLabel ? `Fila: ${r.RowLabel}` : null,
                r.ColumnLabel ? `Col: ${r.ColumnLabel}` : null,
                r.PositionLabel ? `Pos: ${r.PositionLabel}` : null,
                r.Side ? `Lado: ${r.Side}` : null,
            ].filter(Boolean) as string[];

            this.locationTokens = tokens;
        },

        setupWatcher() {
            // cada vez que cambie cualquier campo de ubicación/almacenamiento,
            // reconstruimos el resumen tipo "Variables capturadas"
            watch(
                () => ({
                    SiteName: this.form.record.SiteName,
                    AreaName: this.form.record.AreaName,
                    BuildingName: this.form.record.BuildingName,
                    FloorName: this.form.record.FloorName,
                    RoomName: this.form.record.RoomName,
                    StorageType: this.form.record.StorageType,
                    StorageCode: this.form.record.StorageCode,
                    Shelf: this.form.record.Shelf,
                    RowLabel: this.form.record.RowLabel,
                    ColumnLabel: this.form.record.ColumnLabel,
                    PositionLabel: this.form.record.PositionLabel,
                    Side: this.form.record.Side,
                }),
                () => this.buildLocationTokens(),
                { deep: true }
            );
        },
    },
});
